import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import SimpleSlider from './SimpleSlider';
import GroupMenu from './groupmenu';

class FoodMenu extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'

    return <><div className="propartes-area pd-top-20">
			  <div className="container">
				<div class="slider-nav">
					<div class="row">
						<div class="col-md-12">					
							<SimpleSlider></SimpleSlider>
						</div>
					</div>
				</div>
	
				<section id='things'>
					<div className="section-title text-center">
						<h2>APPETIZERS</h2>
					</div>
					<div className="row go-top">
						<div className="col-lg-4 col-md-6">
							<div className="single-product-wrap style-bottom">
								<div className="thumb">
									<img src={publicUrl+"assets/img/p1.jpg"} alt="img" />
									<div class="btn-area">
										<span class="btn-base btn-sm" data-toggle="modal" data-target="#exampleModalCenter">(LGV)</span>
									</div>
									<div className="product-wrap-details">
										<div className="media">
											<div className="media-body">
												<h6><Link to="/">CHICKEN MASALA</Link></h6>
											</div>
											<a className="fav-btn float-right" href="#"><img src={publicUrl+"assets/img/chilly1.png"} class="chill" alt="img"/></a>
										</div>
									</div> 
								</div> 
								<div className="product-details-inner">
									<p>Lorem ipsum dolor consectetur iicing elit, sed do eius Lorem ipsum dolo amet, costur adipisicing eiusmod.</p>
								</div>
								<div className="product-meta-bottom">
									<div class="row">
										<div class="col-md-6 col-6">
											<span class="price">€ 14.90 </span>
										</div>
										<div class="col-md-6 col-6 text-right">
											<a class="btn btn-base btn-xs" href="#">Add To Cart <i class="fab fa-opencart" aria-hidden="true"></i></a>
										</div>
									</div>
								</div>         
							</div>
						</div>
						<div className="col-lg-4 col-md-6">
							<div className="single-product-wrap style-bottom">
								<div className="thumb">
									<img src={publicUrl+"assets/img/p2.jpg" }alt="img" />
									<div class="btn-area">
										<span class="btn-base btn-sm">(LG)</span>
									</div>
									<div className="product-wrap-details">
										<div className="media">
											<div className="media-body">
												<h6><Link to="/">CHICKEN PILAF BIRYANI</Link></h6>
											</div>
											<a className="fav-btn float-right" href="#"><img src={publicUrl+"assets/img/chilly2.png"} class="chill" alt="img"/></a>
										</div>
									</div> 
								</div> 
								<div className="product-details-inner">
									<p>Lorem ipsum dolor consectetur iicing elit, sed do eius Lorem ipsum dolo amet, costur adipisicing eiusmod.</p>
								</div>
								<div className="product-meta-bottom">
									<div class="row">
										<div class="col-md-6 col-6">
											<span class="price">€ 14.90 </span>
										</div>
										<div class="col-md-6 col-6 text-right">
											<a class="btn btn-base btn-xs" href="#">Add To Cart <i class="fab fa-opencart" aria-hidden="true"></i></a>
										</div>
									</div>
								</div>         
							</div>
						</div>
						<div className="col-lg-4 col-md-6">
							<div className="single-product-wrap style-bottom">
								<div className="thumb">
									<img src={publicUrl+"assets/img/p3.jpg"} alt="img" />
									<div class="btn-area">
										<span class="btn-base btn-sm">(L)</span>
									</div>
									<div className="product-wrap-details">
										<div className="media">
											<div className="media-body">
												<h6><Link to="/">KASVIS THALI / VEG THALI</Link></h6>
											</div>
											<a className="fav-btn float-right" href="#"><img src={publicUrl+"assets/img/chilly3.png"} class="chill" alt="img"/></a>
										</div>
									</div> 
								</div> 
								<div className="product-details-inner">
									<p>Lorem ipsum dolor consectetur iicing elit, sed do eius Lorem ipsum dolo amet, costur adipisicing eiusmod.</p>
								</div>
								<div className="product-meta-bottom">
									<div class="row">
										<div class="col-md-6 col-6">
											<span class="price">€ 14.90 </span>
										</div>
										<div class="col-md-6 col-6 text-right">
											<a class="btn btn-base btn-xs" href="#">Add To Cart <i class="fab fa-opencart" aria-hidden="true"></i></a>
										</div>
									</div>
								</div>         
							</div>
						</div>
						<div className="col-lg-4 col-md-6">
							<div className="single-product-wrap style-bottom">
								<div className="thumb">
								<img src={publicUrl+"assets/img/p4.jpg"} alt="img" />
								<div class="btn-area">
									<span class="btn-base btn-sm">(G)</span>
								</div>
								<div className="product-wrap-details">
									<div className="media">
									<div className="media-body">
										<h6><Link to="/">MIX VEG BIRYANI</Link></h6>
									</div>
									<a className="fav-btn float-right" href="#"><img src={publicUrl+"assets/img/chilly1.png"} class="chill" alt="img"/></a>
									</div>
								</div> 
								</div> 
								<div className="product-details-inner">
									<p>Lorem ipsum dolor consectetur iicing elit, sed do eius Lorem ipsum dolo amet, costur adipisicing eiusmod.</p>
								</div>
								<div className="product-meta-bottom">
									<div class="row">
										<div class="col-md-6 col-6">
											<span class="price">€ 14.90 </span>
										</div>
										<div class="col-md-6 col-6 text-right">
											<a class="btn btn-base btn-xs" href="#">Add To Cart <i class="fab fa-opencart" aria-hidden="true"></i></a>
										</div>
									</div>
								</div>         
							</div>
						</div>
						<div className="col-lg-4 col-md-6">
							<div className="single-product-wrap style-bottom">
								<div className="thumb">
								<img src={publicUrl+"assets/img/p5.jpg"} alt="img" />
								<div class="btn-area">
									<span class="btn-base btn-sm">(V)</span>
								</div>
								<div className="product-wrap-details">
									<div className="media">
									<div className="media-body">
										<h6><Link to="/">FISH CURRY</Link></h6>
									</div>
									<a className="fav-btn float-right" href="#"><img src={publicUrl+"assets/img/chilly2.png"} class="chill" alt="img"/></a>
									</div>
								</div> 
								</div> 
								<div className="product-details-inner">
								<p>Lorem ipsum dolor consectetur iicing elit, sed do eius Lorem ipsum dolo amet, costur adipisicing eiusmod.</p>
								</div>
								<div className="product-meta-bottom">
									<div class="row">
										<div class="col-md-6 col-6">
											<span class="price">€ 14.90 </span>
										</div>
										<div class="col-md-6 col-6 text-right">
											<a class="btn btn-base btn-xs" href="#">Add To Cart <i class="fab fa-opencart" aria-hidden="true"></i></a>
										</div>
									</div>
								</div>         
							</div>
						</div>
						<div className="col-lg-4 col-md-6">
							<div className="single-product-wrap style-bottom">
								<div className="thumb">
								<img src={publicUrl+"assets/img/p6.jpg"} alt="img" />
								<div class="btn-area">
									<span class="btn-base btn-sm">(GV)</span>
								</div>
								<div className="product-wrap-details">
									<div className="media">
									<div className="media-body">
										<h6><Link to="/">LIHA THALI / MEAT THALI</Link></h6>
									</div>
									<a className="fav-btn float-right" href="#"><img src={publicUrl+"assets/img/chilly3.png"} class="chill" alt="img"/></a>
									</div>
								</div> 
								</div> 
								<div className="product-details-inner">
								<p>Lorem ipsum dolor consectetur iicing elit, sed do eius Lorem ipsum dolo amet, costur adipisicing eiusmod.</p>
								</div>
								<div className="product-meta-bottom">
									<div class="row">
										<div class="col-md-6 col-6">
											<span class="price">€ 14.90 </span>
										</div>
										<div class="col-md-6 col-6 text-right">
											<a class="btn btn-base btn-xs" href="#">Add To Cart <i class="fab fa-opencart" aria-hidden="true"></i></a>
										</div>
									</div>
								</div>         
							</div>
						</div>
					</div>
				</section>
				<section id='stuff'>
					<div className="section-title text-center">
						<h2>VEGETABLE DISHES</h2>					
					</div>
					<div className="row go-top">
						<div className="col-lg-4 col-md-6">
							<div className="single-product-wrap style-bottom">
								<div className="thumb">
									<img src={publicUrl+"assets/img/p1.jpg"} alt="img" />
									<div class="btn-area">
										<span class="btn-base btn-sm">(LGV)</span>
									</div>
									<div className="product-wrap-details">
										<div className="media">
											<div className="media-body">
												<h6><Link to="/">CHICKEN MASALA</Link></h6>
											</div>
											<a className="fav-btn float-right" href="#"><img src={publicUrl+"assets/img/chilly1.png"} class="chill" alt="img"/></a>
										</div>
									</div> 
								</div> 
								<div className="product-details-inner">
									<p>Lorem ipsum dolor consectetur iicing elit, sed do eius Lorem ipsum dolo amet, costur adipisicing eiusmod.</p>
								</div>
								<div className="product-meta-bottom">
									<div class="row">
										<div class="col-md-6 col-6">
											<span class="price">€ 14.90 </span>
										</div>
										<div class="col-md-6 col-6 text-right">
											<a class="btn btn-base btn-xs" href="#">Add To Cart <i class="fab fa-opencart" aria-hidden="true"></i></a>
										</div>
									</div>
								</div>         
							</div>
						</div>
						<div className="col-lg-4 col-md-6">
							<div className="single-product-wrap style-bottom">
								<div className="thumb">
									<img src={publicUrl+"assets/img/p2.jpg" }alt="img" />
									<div class="btn-area">
										<span class="btn-base btn-sm">(LG)</span>
									</div>
									<div className="product-wrap-details">
										<div className="media">
											<div className="media-body">
												<h6><Link to="/">CHICKEN PILAF BIRYANI</Link></h6>
											</div>
											<a className="fav-btn float-right" href="#"><img src={publicUrl+"assets/img/chilly2.png"} class="chill" alt="img"/></a>
										</div>
									</div> 
								</div> 
								<div className="product-details-inner">
									<p>Lorem ipsum dolor consectetur iicing elit, sed do eius Lorem ipsum dolo amet, costur adipisicing eiusmod.</p>
								</div>
								<div className="product-meta-bottom">
									<div class="row">
										<div class="col-md-6 col-6">
											<span class="price">€ 14.90 </span>
										</div>
										<div class="col-md-6 col-6 text-right">
											<a class="btn btn-base btn-xs" href="#">Add To Cart <i class="fab fa-opencart" aria-hidden="true"></i></a>
										</div>
									</div>
								</div>         
							</div>
						</div>
						<div className="col-lg-4 col-md-6">
							<div className="single-product-wrap style-bottom">
								<div className="thumb">
									<img src={publicUrl+"assets/img/p3.jpg"} alt="img" />
									<div class="btn-area">
										<span class="btn-base btn-sm">(L)</span>
									</div>
									<div className="product-wrap-details">
										<div className="media">
											<div className="media-body">
												<h6><Link to="/">KASVIS THALI / VEG THALI</Link></h6>
											</div>
											<a className="fav-btn float-right" href="#"><img src={publicUrl+"assets/img/chilly3.png"} class="chill" alt="img"/></a>
										</div>
									</div> 
								</div> 
								<div className="product-details-inner">
									<p>Lorem ipsum dolor consectetur iicing elit, sed do eius Lorem ipsum dolo amet, costur adipisicing eiusmod.</p>
								</div>
								<div className="product-meta-bottom">
									<div class="row">
										<div class="col-md-6 col-6">
											<span class="price">€ 14.90 </span>
										</div>
										<div class="col-md-6 col-6 text-right">
											<a class="btn btn-base btn-xs" href="#">Add To Cart <i class="fab fa-opencart" aria-hidden="true"></i></a>
										</div>
									</div>
								</div>         
							</div>
						</div>
						<div className="col-lg-4 col-md-6">
							<div className="single-product-wrap style-bottom">
								<div className="thumb">
								<img src={publicUrl+"assets/img/p4.jpg"} alt="img" />
								<div class="btn-area">
									<span class="btn-base btn-sm">(G)</span>
								</div>
								<div className="product-wrap-details">
									<div className="media">
									<div className="media-body">
										<h6><Link to="/">MIX VEG BIRYANI</Link></h6>
									</div>
									<a className="fav-btn float-right" href="#"><img src={publicUrl+"assets/img/chilly1.png"} class="chill" alt="img"/></a>
									</div>
								</div> 
								</div> 
								<div className="product-details-inner">
									<p>Lorem ipsum dolor consectetur iicing elit, sed do eius Lorem ipsum dolo amet, costur adipisicing eiusmod.</p>
								</div>
								<div className="product-meta-bottom">
									<div class="row">
										<div class="col-md-6 col-6">
											<span class="price">€ 14.90 </span>
										</div>
										<div class="col-md-6 col-6 text-right">
											<a class="btn btn-base btn-xs" href="#">Add To Cart <i class="fab fa-opencart" aria-hidden="true"></i></a>
										</div>
									</div>
								</div>         
							</div>
						</div>
						<div className="col-lg-4 col-md-6">
							<div className="single-product-wrap style-bottom">
								<div className="thumb">
								<img src={publicUrl+"assets/img/p5.jpg"} alt="img" />
								<div class="btn-area">
									<span class="btn-base btn-sm">(V)</span>
								</div>
								<div className="product-wrap-details">
									<div className="media">
									<div className="media-body">
										<h6><Link to="/">FISH CURRY</Link></h6>
									</div>
									<a className="fav-btn float-right" href="#"><img src={publicUrl+"assets/img/chilly2.png"} class="chill" alt="img"/></a>
									</div>
								</div> 
								</div> 
								<div className="product-details-inner">
								<p>Lorem ipsum dolor consectetur iicing elit, sed do eius Lorem ipsum dolo amet, costur adipisicing eiusmod.</p>
								</div>
								<div className="product-meta-bottom">
									<div class="row">
										<div class="col-md-6 col-6">
											<span class="price">€ 14.90 </span>
										</div>
										<div class="col-md-6 col-6 text-right">
											<a class="btn btn-base btn-xs" href="#">Add To Cart <i class="fab fa-opencart" aria-hidden="true"></i></a>
										</div>
									</div>
								</div>         
							</div>
						</div>
						<div className="col-lg-4 col-md-6">
							<div className="single-product-wrap style-bottom">
								<div className="thumb">
								<img src={publicUrl+"assets/img/p6.jpg"} alt="img" />
								<div class="btn-area">
									<span class="btn-base btn-sm">(GV)</span>
								</div>
								<div className="product-wrap-details">
									<div className="media">
									<div className="media-body">
										<h6><Link to="/">LIHA THALI / MEAT THALI</Link></h6>
									</div>
									<a className="fav-btn float-right" href="#"><img src={publicUrl+"assets/img/chilly3.png"} class="chill" alt="img"/></a>
									</div>
								</div> 
								</div> 
								<div className="product-details-inner">
								<p>Lorem ipsum dolor consectetur iicing elit, sed do eius Lorem ipsum dolo amet, costur adipisicing eiusmod.</p>
								</div>
								<div className="product-meta-bottom">
									<div class="row">
										<div class="col-md-6 col-6">
											<span class="price">€ 14.90 </span>
										</div>
										<div class="col-md-6 col-6 text-right">
											<a class="btn btn-base btn-xs" href="#">Add To Cart <i class="fab fa-opencart" aria-hidden="true"></i></a>
										</div>
									</div>
								</div>         
							</div>
						</div>
					</div>
				</section>
			    
				
			  </div>
			</div>
			<GroupMenu></GroupMenu></>

        }
}

export default FoodMenu